import devWarning, { resetWarned } from './warning';
export { resetWarned };
export default (valid, component, message) => {
    if (process.env.NODE_ENV !== 'production')
        devWarning(valid, `[wetrade-design: ${component}] ${message}`);
};
